import { Environment, OAUTH_CLIENTS, Partner  } from "config"

type DmsSettings = {
  endpoint: string
  partnerId: number
}

export function getOauthClient({ debugConfig, dmsSettings }: { dmsSettings: DmsSettings, debugConfig?: Partial<DmsSettings> }) {
  const partnerId = debugConfig?.partnerId || dmsSettings.partnerId
  const endpoint = debugConfig?.endpoint || dmsSettings.endpoint

  const [, env] = endpoint.split('.') as [string, Environment]

  return OAUTH_CLIENTS[env][partnerId as Partner]
}
